import { useState, useEffect } from "react";
import Logo from "./Logo";

const navLinks = [
  { label: "Accueil", href: "/", icon: "ri-home-4-line" },
  { label: "Oscillo-battant", href: "/reglage-fenetre-oscillo-battant", icon: "ri-window-line" },
  { label: "Crémone & poignée", href: "/cremone-fenetre", icon: "ri-door-lock-line" },
  { label: "Nos prestations", href: "/nos-prestations", icon: "ri-tools-line" },
  { label: "Zones", href: "/zones-dinterventions", icon: "ri-map-pin-line" },
  { label: "Contact", href: "/contact", icon: "ri-mail-send-line" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/95 backdrop-blur-md shadow-[0_2px_20px_rgba(30,58,71,0.08)]"
            : "bg-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Mobile burger */}
            <button
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-white/10 transition-colors"
              onClick={() => setMenuOpen(true)}
              aria-label="Menu"
            >
              <i className={`ri-menu-3-line text-xl ${scrolled ? "text-plum-dark" : "text-white"}`} />
            </button>

            {/* Logo desktop */}
            <a href="/" className="hidden md:flex items-center gap-2 whitespace-nowrap">
              <Logo variant="header" isDark={!scrolled} />
            </a>

            {/* Logo mobile */}
            <a href="/" className="md:hidden flex items-center whitespace-nowrap">
              <Logo variant="header-mobile" isDark={!scrolled} />
            </a>

            {/* Desktop nav */}
            <nav className="hidden md:flex items-center gap-6 lg:gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-coral ${
                    scrolled ? "text-plum-dark" : "text-white/90"
                  }`}
                >
                  {link.label}
                </a>
              ))}
            </nav>

            {/* Desktop phone button */}
            <a
              href="tel:0374471036"
              className={`hidden md:flex items-center gap-2 px-5 py-2.5 rounded-xl border text-sm font-semibold whitespace-nowrap transition-all ${
                scrolled
                  ? "border-plum text-plum hover:bg-plum hover:text-white"
                  : "border-white/60 text-white hover:bg-white hover:text-plum"
              }`}
            >
              <i className="ri-phone-line" />
              03 74 47 10 36
            </a>
          </div>
        </div>
      </header>

      {/* Mobile overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 z-[60] bg-black/30 backdrop-blur-sm transition-opacity"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* Mobile slide-in menu */}
      <div
        className={`fixed top-0 right-0 bottom-0 z-[70] w-[80%] max-w-[320px] bg-white shadow-2xl transform transition-transform duration-300 ease-out ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-5 h-16 border-b border-rose-200">
            <Logo variant="header-mobile" isDark={false} />
            <button
              className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-rose-50 transition-colors text-plum-dark"
              onClick={() => setMenuOpen(false)}
              aria-label="Fermer"
            >
              <i className="ri-close-line text-2xl" />
            </button>
          </div>
          <nav className="flex-1 overflow-y-auto px-5 py-6">
            <div className="space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-plum-dark font-medium hover:bg-[#EEF2F4] hover:text-[#FF6B4A] transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  <i className={`${link.icon} text-lg text-[#FF6B4A]/70`} />
                  {link.label}
                </a>
              ))}
            </div>
          </nav>
          <div className="p-5 border-t border-rose-200 space-y-3">
            <a
              href="tel:0374471036"
              className="flex items-center justify-center gap-2 w-full py-3.5 rounded-xl bg-[#FF6B4A] text-white font-semibold text-base shadow-lg shadow-[#FF6B4A]/20 hover:bg-[#FF6B4A]/90 transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              <i className="ri-phone-line" />
              Appeler 03 74 47 10 36
            </a>
            <a
              href="/contact"
              className="flex items-center justify-center gap-2 w-full py-3.5 rounded-xl border border-[#D7E0E4] text-[#1E3A47] font-semibold text-base hover:bg-[#EEF2F4] transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              <i className="ri-edit-line" />
              Devis gratuit
            </a>
          </div>
        </div>
      </div>
    </>
  );
}